import { PREVIEW_THEATER_SUBSCRIPTION_CAPACITY } from '@/graphql/theater-subscriptions.graphql'

export default {
  data() {
    return {
      capacitySummary: null, capacityLoading: false, capacityError: '', capacityRequest: 0,
      capacityTimer: null, capacityActiveTouched: false, capacityIsCreate: false,
      showEmptyCapacityWarning: false,
    }
  },
  computed: {
    capacityIsGeneralAdmission() {
      const venue = this.venues.find(item => Number(item.id) === Number(this.selectedVenue))

      return !!venue && !(venue.seats && venue.seats.length && venue.predefinedSections)
    },
    capacityPreviewInput() {
      const plan = this.subscriptionPlan
      if (!this.capacityIsGeneralAdmission || this.showSubscriptionPlanModal === false ||
          !plan.valid_from || !plan.valid_to || !Number.isFinite(new Date(plan.valid_from).getTime()) ||
          !Number.isFinite(new Date(plan.valid_to).getTime()) || new Date(plan.valid_from) >= new Date(plan.valid_to)) return null

      return {
        organizationSlug: this.organizationSlug, venueId: Number(this.selectedVenue),
        valid_from: new Date(plan.valid_from).toISOString(), valid_to: new Date(plan.valid_to).toISOString(),
        ...(plan.id ? { subscriptionId: Number(plan.id) } : {}),
      }
    },
    capacityPreviewKey() { return JSON.stringify(this.capacityPreviewInput) },
  },
  watch: {
    capacityPreviewKey: {
      immediate: true,
      handler() {
        clearTimeout(this.capacityTimer)
        this.capacityRequest++
        this.capacitySummary = null
        this.capacityError = ''
        this.capacityLoading = !!this.capacityPreviewInput
        this.capacityTimer = setTimeout(() => this.refreshCapacityPreview(), 250)
      },
    },
  },
  beforeDestroy() {
    clearTimeout(this.capacityTimer)
    this.capacityRequest++
  },
  methods: {
    async refreshCapacityPreview() {
      clearTimeout(this.capacityTimer)
      const request = ++this.capacityRequest
      const input = this.capacityPreviewInput
      const key = this.capacityPreviewKey
      if (!input) {
        this.capacitySummary = null
        this.capacityLoading = false

        return !this.capacityIsGeneralAdmission
      }
      this.capacityLoading = true
      this.capacityError = ''
      try {
        const { data } = await this.$apollo.query({
          query: PREVIEW_THEATER_SUBSCRIPTION_CAPACITY, variables: { input }, fetchPolicy: 'network-only',
        })
        if (request !== this.capacityRequest || key !== this.capacityPreviewKey) return false
        if (!data || !data.previewTheaterSubscriptionCapacity) throw new Error('Missing capacity preview')
        this.capacitySummary = data.previewTheaterSubscriptionCapacity
        if (this.capacityIsCreate && !this.capacityActiveTouched && this.capacitySummary.includedEventCount === 0) {
          this.subscriptionPlan.active = false
        }

        return true
      } catch (_) {
        if (request === this.capacityRequest && key === this.capacityPreviewKey) {
          this.capacitySummary = null
          this.capacityError = this.adminText('organizationAll.ga_capacity_error', 'Could not load performance capacity. Please retry before saving.')
        }

        return false
      } finally {
        if (request === this.capacityRequest && key === this.capacityPreviewKey) this.capacityLoading = false
      }
    },
    async prepareCapacitySave(confirmedEmpty = false) {
      if (!this.capacityIsGeneralAdmission) return true
      if (!this.capacityPreviewInput) {
        this.capacityError = this.adminText('organizationAll.end_date_must_be_after_start_date_f6d46935', 'End date must be after start date')

        return false
      }
      if (!(await this.refreshCapacityPreview())) return false
      if (this.capacitySummary.includedEventCount === 0 && confirmedEmpty !== true) {
        this.showEmptyCapacityWarning = true

        return false
      }
      this.showEmptyCapacityWarning = false

      return true
    },
  },
}
